export default {
  // Common
  appName: 'MeetTix',
  loading: 'Carregando...',
  error: 'Ocorreu um erro. Por favor, tente novamente.',
  authError: 'Falha na autenticação. Por favor, verifique suas credenciais e tente novamente.',
  
  // Navigation
  nav: {
    home: 'Início',
    events: 'Eventos',
    pastEvents: 'Eventos Passados',
    login: 'Entrar',
    register: 'Cadastrar',
    profile: 'Perfil',
    myTickets: 'Meus Ingressos',
    adminDashboard: 'Painel de Administração',
    signOut: 'Sair'
  },
  
  // Home Page
  home: {
    hero: {
      title: 'Encontre e Reserve Eventos Incríveis',
      subtitle: 'Descubra shows, esportes, teatro e muito mais na sua cidade. Compre ingressos para os eventos que você ama!'
    },
    featuredEvents: 'Eventos em Destaque',
    eventsInCity: 'Eventos em {{city}}',
    noUpcomingEvents: 'Nenhum evento próximo em {{city}}',
    viewAll: 'Ver Todos',
    browseByCategory: 'Navegar por Categoria',
    howItWorks: 'Como Funciona',
    howItWorksSteps: {
      search: {
        title: 'Buscar Eventos',
        description: 'Encontre eventos por localização, categoria ou data que correspondam aos seus interesses.'
      },
      book: {
        title: 'Reservar Ingressos',
        description: 'Garanta seu lugar com nosso processo de reserva fácil e seguro.'
      },
      attend: {
        title: 'Participar do Evento',
        description: 'Prepare-se para desfrutar de uma experiência inesquecível no evento escolhido.'
      }
    },
    cta: {
      title: 'Pronto para descobrir eventos incríveis?',
      subtitle: 'Junte-se a milhares de pessoas que usam o MeetTix para encontrar e reservar ingressos para os melhores eventos.',
      button: 'Cadastre-se Agora'
    }
  },
  
  // Events Page
  events: {
    title: 'Explorar Eventos',
    eventsFound: '{{count}} evento encontrado',
    eventsFound_plural: '{{count}} eventos encontrados',
    noEvents: 'Nenhum evento encontrado com seus critérios.',
    resetFilters: 'Redefinir Filtros',
    viewDetails: 'Ver Detalhes',
    free: 'Grátis'
  },
  
  // Event Detail Page
  eventDetail: {
    aboutEvent: 'Sobre Este Evento',
    venueInfo: 'Informações do Local',
    getTickets: 'Obter Ingressos',
    price: 'Preço:',
    quantity: 'Quantidade',
    ticketsAvailable: '{{count}} ingresso disponível',
    ticketsAvailable_plural: '{{count}} ingressos disponíveis',
    buyTickets: 'Comprar Ingressos',
    loginToBuy: 'Entre para Comprar Ingressos',
    soldOut: 'Esgotado',
    secureCheckout: 'Pagamento seguro • Confirmação instantânea',
    notFound: 'Evento não encontrado.',
    buyTicketsExternal: 'Comprar com desconto',
    checkIn: {
      title: 'Check-ins ({{count}})',
      button: 'Fazer Check-in',
      alreadyCheckedIn: 'Já fez Check-in',
      processing: 'Fazendo Check-in...',
      error: 'Falha ao fazer check-in. Tente novamente.',
      commentPlaceholder: 'Compartilhe sua opinião sobre o evento...',
      writeComment: 'Escreva um comentário...'
    },
    anonymousUser: 'Usuário Anônimo',
    invalidDate: 'Data inválida'
  },
  
  // Search Bar
  search: {
    city: 'Cidade',
    allCities: 'Todas as Cidades',
    eventType: 'Tipo de Evento',
    allCategories: 'Todas as Categorias',
    date: 'Data',
    search: 'Buscar'
  },
  
  // Categories
  categories: {
    concert: 'Shows',
    sports: 'Esportes',
    theater: 'Teatro',
    conference: 'Conferências',
    festival: 'Festivais',
    other: 'Outros'
  },
  
  // Auth Pages
  auth: {
    login: {
      title: 'Entre na sua conta',
      noAccount: 'Ou crie uma nova conta',
      email: 'Endereço de e-mail',
      password: 'Senha',
      rememberMe: 'Lembrar-me',
      forgotPassword: 'Esqueceu sua senha?',
      signIn: 'Entrar',
      signingIn: 'Entrando...',
      continueWith: 'Ou continue com',
      google: 'Google'
    },
    register: {
      title: 'Crie sua conta',
      haveAccount: 'Ou entre na sua conta existente',
      name: 'Nome completo',
      email: 'Endereço de e-mail',
      password: 'Senha',
      confirmPassword: 'Confirmar Senha',
      passwordsDoNotMatch: 'As senhas não coincidem',
      passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
      terms: 'Eu concordo com os Termos de Serviço e Política de Privacidade',
      createAccount: 'Criar Conta',
      creatingAccount: 'Criando conta...',
      continueWith: 'Ou continue com',
      google: 'Google'
    },
    resetPassword: {
      title: 'Recuperar Senha',
      email: 'Endereço de email',
      send: 'Enviar Link de Recuperação',
      sending: 'Enviando...',
      backToLogin: 'Voltar para Login',
      success: 'Email de recuperação enviado! Verifique sua caixa de entrada.',
      error: 'Falha ao enviar email de recuperação. Tente novamente.'
    },
    errors: {
      invalidEmail: 'Endereço de e-mail inválido.',
      userDisabled: 'Esta conta foi desativada.',
      invalidCredential: 'E-mail ou senha incorretos.',
      tooManyRequests: 'Muitas tentativas. Tente novamente em alguns minutos.',
      network: 'Erro de rede. Verifique sua conexão e tente novamente.',
      operationNotAllowed: 'Login por e-mail/senha não está habilitado. Entre em contato com o suporte.',
      emailInUse: 'Este e-mail já está cadastrado.',
      weakPassword: 'A senha deve ter pelo menos 6 caracteres.',
      popupClosed: 'A janela de login foi fechada antes de concluir.'
    }
  },

  // Profile Page
  profile: {
    title: 'Perfil',
    fields: {
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      phoneNotSet: 'Não definido',
      enterPhone: 'Digite seu número de telefone'
    },
    buttons: {
      edit: 'Editar Perfil',
      save: 'Salvar Alterações',
      saving: 'Salvando...',
      cancel: 'Cancelar',
      signOut: 'Sair'
    },
    errors: {
      updateFailed: 'Falha ao atualizar perfil',
      photoUploadFailed: 'Falha ao enviar foto'
    }
  },
  
  // Admin
  admin: {
    dashboard: {
      title: 'Painel de Administração',
      addEvent: 'Adicionar Novo Evento',
      noEvents: 'Nenhum evento encontrado.',
      createFirst: 'Crie Seu Primeiro Evento',
      event: 'Evento',
      dateTime: 'Data e Hora',
      location: 'Local',
      price: 'Preço',
      tickets: 'Ingressos',
      actions: 'Ações',
      confirmDelete: 'Confirmar exclusão?',
      yes: 'Sim',
      no: 'Não'
    },
    eventForm: {
      createEvent: 'Criar Novo Evento',
      editEvent: 'Editar Evento',
      back: 'Voltar ao Painel',
      eventTitle: 'Título do Evento',
      description: 'Descrição',
      venue: 'Local',
      city: 'Cidade',
      selectCity: 'Selecione uma cidade',
      date: 'Data',
      time: 'Hora',
      category: 'Categoria',
      selectCategory: 'Selecione uma categoria',
      price: 'Preço (R$)',
      availableTickets: 'Ingressos Disponíveis',
      ticketUrl: 'URL de Compra de Ingressos',
      ticketUrlPlaceholder: 'https://exemplo.com/comprar-ingressos',
      ticketUrlHelp: 'Site externo onde os usuários podem comprar ingressos',
      eventImage: 'Imagem do Evento',
      uploadImage: 'Carregar imagem',
      imageTypes: 'PNG, JPG, GIF até 10MB',
      cancel: 'Cancelar',
      update: 'Atualizar Evento',
      create: 'Criar Evento',
      updating: 'Atualizando...',
      creating: 'Criando...',
      fillAllFields: 'Por favor, preencha todos os campos obrigatórios'
    }
  },
  
  // Footer
  footer: {
    description: 'Encontre e reserve ingressos para os melhores eventos da sua cidade. Shows, esportes, teatro e muito mais.',
    quickLinks: 'Links Rápidos',
    categories: 'Categorias',
    contactUs: 'Contate-nos',
    newsletter: {
      title: 'Assine nossa newsletter',
      placeholder: 'Seu e-mail',
      button: 'Assinar'
    },
    copyright: '© {{year}} MeetTix. Todos os direitos reservados.',
    policies: {
      privacy: 'Política de Privacidade',
      terms: 'Termos de Serviço',
      cookies: 'Política de Cookies'
    }
  }
};